import React from "react";
import PageLoader from "../components/PageLoader/PageLoader";
import cn from "classnames";

/** Page chrome (header/footer) lives in `TreydoraSiteShell`; this layout is content + loader only. */
const LayoutOne = (props) => {
  return (
    <div className={cn("td-layout-one")}>
      <PageLoader />
      {props.children}
    </div>
  );
};

export default LayoutOne;
